
import ReactDOM from 'react-dom'
import { UIPlugin } from '@uppy/core';
import { Provider } from '@uppy/companion-client';
import { h } from 'preact'
import React from 'react'
import UppyQrComponent from './uppyQrComponent'


export default class QrProvider extends UIPlugin {
  constructor(uppy, opts) {
    super(uppy, opts);
    this.id = 'qr';
    this.title = 'Mobile Device';
    this.type = 'acquirer'

    Provider.initPlugin(this, opts);

    this.icon = () =>
      h(
        'svg',
        {
          'aria-hidden': 'true',
          focusable: 'false',
          width: '32',
          height: '32',
          viewBox: '0 0 512 512',
        },
        h(
          'g',
          {
            fill: 'none',
            fillRule: 'evenodd',
          },
          h('path', {
            d:
              'M304.576 119.703h-97.148c-18.358 0-33.247 11.434-33.247 25.54v221.509c0 14.106 14.89 25.545 33.247 25.545h97.148c18.359 0 33.243-11.44 33.243-25.545V145.243c0-14.111-14.884-25.54-33.243-25.54zm-73.68 13.752h50.213v14.115h-50.213zm42.132 242.629h-34.05v-14.116h34.05zm44.025-31.51H194.947V163.39h122.106z',
            fill: '#000000',
          }),
        ),
      );


    this.render = this.render.bind(this);
  }

  render() {
    setTimeout(() => {
      const element = document.getElementById("uppy-DashboardContent-panel--qr");
      if (element) {
        const body = element.getElementsByClassName("uppy-DashboardContent-panelBody")[0];
        if (body) {
          ReactDOM.render(
            <UppyQrComponent
              paraboAccessToken={this.opts.paraboAccessToken}
              onUpload={this.opts.onUpload}
              onDone={this.opts.onDone}
              maxNumberOfFiles={this.opts.maxNumberOfFiles}
            />,
            body,
          )
        }
      }
    })
  }

  install() {
    const { target } = this.opts
    if (target) {
      this.mount(target, this)
    }
  }

  uninstall() {
    this.unmount()
  }
}
QrProvider.VERSION = '1.0.0';

